import { format } from 'date-fns';
import { enUS, id } from 'date-fns/locale';
import { useRouter } from 'next/router';
import React from 'react';

export interface FormatDateOptions {
  locale?: Locale;
  weekStartsOn?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
  firstWeekContainsDate?: number;
  useAdditionalWeekYearTokens?: boolean;
  useAdditionalDayOfYearTokens?: boolean;
}

export default function useDate() {
  const { locale } = useRouter();

  const formatDate = React.useCallback(
    (
      date: Date,
      dateFormat: string = 'dd MMMM yyyy',
      options?: FormatDateOptions,
    ) => {
      try {
        return format(date, dateFormat, {
          ...options,
          locale: locale === 'id' ? id : enUS,
        });
      } catch (e) {
        console.error(e.message);
        return '';
      }
    },
    [locale],
  );

  return formatDate;
}
